import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class tagsService extends ApiBaseService {
  constructor(public http: HttpClient) {
    super(http, '/tags');
  }

  checkNameExists(name: string, id?: boolean | number): Observable<any> {
    const tagId = id ? id : null;
    const params = { name, tagId };
    return this.http.get(`${environment.apiUrl}/tags/check`, {
      params,
    });
  }
}
